import httpClient from '../axios';

const URL = 'profile';

const profile = async (data) => httpClient.post(URL, data);

export default profile;
